export default __webpack_public_path__ + "10de96e63ec0907211e47c24df0eb35e.png";